import React, {FC, Fragment} from "react";
import cls from "../shop.module.scss";
import {ArrowBackSvg, FailSvg} from "../../../svg";
import Link from "next/link";
import Currency from "../../shared/Currency";
import CartTotalPriceInfo from "./CartTotalPriceInfo";
import {TranslationsType} from "../../../types/homePageTypes";
import {useToast} from "../../../atoms/Toast/useToast";
interface IActionsProps {
    translationsData: TranslationsType;
    subTotalForCart: string;
    checkoutHrefHandle: "/signin" | "/checkout";
    ToastSignInIntl: string
}

const CartActions:FC<IActionsProps> = (
    {
        translationsData: {
            ContinueShopping: ContinueShoppingIntl,
            TotalPrice: TotalPriceIntl,
            Checkout: CheckoutIntl
        },
        subTotalForCart,
        checkoutHrefHandle,
        ToastSignInIntl
    }
) => {
    const toast = useToast();
    return (
        <Fragment>
            <div className={cls.cart__actions}>
                <div className={`${cls.cart__buttons} d-flex`}>
                    <div className={`${cls["continue--arrow"]} ${cls["continue-shopping-title"]}`}>
                        <ArrowBackSvg className={cls["continue--arrow"]}/>
                        <Link href="/">
                            <a>{ContinueShoppingIntl}</a>
                        </Link>
                    </div>
                    <CartTotalPriceInfo TotalPriceIntl={TotalPriceIntl} subTotalForCart={subTotalForCart}/>
                </div>
            </div>
            <div className={cls["cart__totals-td"]}>
                <Link href={checkoutHrefHandle}>
                    <button
                        onClick={() => {
                            if (checkoutHrefHandle === "/signin") {
                                toast.open(
                                    <span className="d-flex faild-toast-fms">
                                        <FailSvg/>
                                        {ToastSignInIntl}
                                    </span>
                                )
                            }
                        }}
                        className={`btn btn-orange btn-lg ${cls["cart__checkout-button"]} f16`}
                    >
                        {CheckoutIntl}
                    </button>
                </Link>
            </div>
        </Fragment>
    )
}

export default CartActions;
